import { Controller } from "stimulus";
import { validCID } from "../services/field-validation_services";

export default class extends Controller {
  connect() {}

  validateCID(event) {
    const submitButton = document.getElementById("track-application-submit");
    if (validCID(event.target.value)) {
      submitButton.classList.remove("disabled");
    } else {
      submitButton.classList.add("disabled");
    }
  }
}
